module.exports = {
	BASE_URL: "https://tools-api-service.sharechat.com",
	UPLOAD_MEDIA_API:
		"https://apis.sharechat.com/media-upload-service/v1.0.0/fileUpload",
	SHARECHAT_DOMAIN: "https://sharechat.com",
	razorPayMTGPLKey: "rzp_live_aominVXs3pVCxY",
	razorpayMTPLKey: "rzp_live_aominVXs3pVCxY",
	razorpayMojKey: "rzp_live_UT5uFRv8wkuu6D",
	JEET11_API_GATEWAY_BASE_URL: "https://api.jeet11.com/",
	FCM_CONFIG: {
		apiKey: "AIzaSyBMyyk4UwY1ue-009eiK5gYpYKSh-8RDWs",
		authDomain: "bharat11-prod.firebaseapp.com",
		databaseURL: "https://bharat11-prod.firebaseio.com",
		projectId: "bharat11-prod",
		storageBucket: "bharat11-prod.appspot.com",
		messagingSenderId: "780950389064",
		appId: "1:780950389064:web:7b010c52955f826b67337d",
		measurementId: "G-8L16XWGDW1"
	},
	FIREBASE_VERSION: "8.2.0",
	ALL_SPORTS: [
		{ id: "b6f7c4cf-ecc0-4dcf-a166-5edd1fda53ea", name: "Cricket" },
		{ id: "89514c4b-08cf-4e59-b40f-911a5bf77421", name: "Football" },
		{ id: "c4d40be5-1c38-4510-ad59-11ccded742ef", name: "Kabaddi" }
	],
	GOOGLE_API_KEY: "AIzaSyBZdte6GccO_mJPYQm3nYp1oU5ZzFhzzu4",
	SHARECHAT_API_DOMAIN: "https://apis.sharechat.com"
};
